export default __webpack_public_path__ + "static/media/search-white.5bfbf7b4.svg";